import React, { useMemo, useState } from 'react';

import {
  Drawer, DrawerCloseButton, DrawerContent, Flex,
} from '@chakra-ui/react';
import dayjs from 'dayjs';

import HistoryMenu from 'containers/History/Menu';
import { InfoRow } from 'containers/Texts';
import useRouteStore from 'stores/useRoute';

import HistoryRow from './Row';

export default function HistorySidebar({ isOpen, onClose }) {
  const { route, history } = useRouteStore();
  const [mode, setMode] = useState<'current' | 'all'>('current');

  const data = useMemo(() => (mode === 'current' ? history : route.history), [mode, route, history]);

  const firstEvent = useMemo(() => data?.shift(), [route, history]);

  return (
    <Drawer
      blockScrollOnMount={false}
      isOpen={isOpen}
      placement="right"
      onClose={onClose}>
      <DrawerContent
        mt={14}>
        <DrawerCloseButton
          _active={{}}
          _focus={{}}
          onClick={onClose}
        />
        <Flex
          overflowY="scroll"
          shadow={2}
          h="100%"
          bg="white"
          flexDir="column"
          p={6}
          pl={4}>
          <HistoryMenu
            mode={mode}
            setMode={setMode}
          />
          <Flex
            mb={10}
            flexDir="column">
            <InfoRow
              label="Criação da Rota:"
              value={dayjs(firstEvent?.createdAt).format('DD/MM/YYYY') || 'N/A'}
            />
            <InfoRow
              label="Status:"
              value={route?.status || 'N/A'}
            />
            <InfoRow
              label="Liberada por:"
              value={firstEvent?.user?.name || 'N/A'}
            />
          </Flex>
          {data?.map((item) => (
            <HistoryRow
              key={`history-row-${item.id}`}
              data={item}
            />
          ))}
        </Flex>
      </DrawerContent>
    </Drawer>
  );
}
